<template>
  <div id="checkout-loading-wrapper">
    <div class="circle-wrapper">
      <div :class="{ 'loader-circle': isToLoad }"/>
      <div class="img-background" :class="[backgroundClass]">
        <Asset
          :name="asset"
          alt="Loading"
          title="Loading"
          id="checkout-loading"/>
      </div>
    </div>
    <div class="loading-text">
      {{text}}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Asset from '@/components/common/Asset.vue';

export default {
  name: 'lock-loader',
  components: {
    Asset,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    asset: {
      type: String,
      default: 'lock-icon.svg',
    },
    isToLoad: {
      type: Boolean,
      default: true,
    },
    backgroundClass: {
      type: String,
    },
  },
  computed: {
    ...mapState('theme', ['theme']),
  },
  mounted() {
    document.documentElement.setAttribute('theme', this.theme);
  },
};
</script>

<style lang="scss" scoped>
.circle-wrapper {
  display: flex;
  justify-content: center;
}

#checkout-loading {
  width: 36px;
  height: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#checkout-loading-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 213px;
  min-height: 126px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.loading-text {
  position: absolute;
  margin-top: 95px;
  text-align: center;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  font-feature-settings: 'ordn' on;
  @extend .gray-600;
}

.loader-circle {
  align-self: center;
  border: 6px solid;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  border-color: var(--primary) var(--primary) transparent;
  animation: spin 1s linear infinite;
  position: absolute;
}

.img-background {
  position: relative;
  background: var(--gray-200);
  border-radius: 50%;
  width: 78px;
  height: 78px;
  &.primary-extra-light {
    background: var(--primary-extra-light)
  }
  &.warning-light {
    background: var(--warning-light)
  }
}

@keyframes spin {
  100%{transform: rotate(360deg)}
}
</style>
